import { ForecastWindDirection } from 'pleinchamp-api-client';
import { MoonIcon } from '@components/icons/meteo/Moon.icon';
import { PlcTextListLoader } from '@components/Loaders/PlcTextLoader.component';
import { Text } from '@components/Text/Text.component';
import { TextProps } from '@components/Text/Text.types';
import style from '@meteo/components/MeteoWeatherTable/MeteoWeatherTableContent/MeteoWeatherTableContent.module.scss';
import { MoonPhase } from '@meteo/types';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import { formatNumberWithComma } from '@utils/number';
import classnames from 'classnames';

type Data = string | number | ForecastWindDirection;

interface CellProps {
  data: Data;
  isDecimal: boolean;
  emphasis: boolean;
  onMouseEnter: () => void;
  isLoading?: boolean;
  isMoonPhase: boolean;
}

const TEXT_PROPS: TextProps[] = [{ variant: 'h6', width: 25 }];

function formatData(data: Data, isMoonPhase: boolean, isDecimal: boolean) {
  if (isMoonPhase) {
    return <MoonIcon phase={data as MoonPhase} />;
  }
  if (isDecimal) {
    return formatNumberWithComma(data as number, 1);
  }
  if (typeof data === 'number') {
    return formatNumberWithComma(data);
  }

  if (typeof data === 'object') {
    return (data as ForecastWindDirection).cardinal;
  }

  return data;
}

function MeteoMetricCell({ data, isMoonPhase, isDecimal, emphasis, onMouseEnter, isLoading }: CellProps) {
  const isSmartphone = useIsBreakpointDown(Breakpoint.m);

  const content: string | number | JSX.Element = formatData(data, isMoonPhase, isDecimal);
  const className = classnames(emphasis ? style.emphasis : '');

  return (
    <td className={className} onMouseEnter={onMouseEnter}>
      <div>
        {isLoading ? (
          <PlcTextListLoader fixedWidth textProps={TEXT_PROPS} uniqueKey="MeteoMetricCell" />
        ) : (
          <Text tag="span" variant={isSmartphone ? 'h5' : 'h6'}>
            {content}
          </Text>
        )}
      </div>
    </td>
  );
}

export { MeteoMetricCell };
